



























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from '@pan-gms/vuetify-jsonschema-form';
import TopNavigationComponent from "./TopNavigation.vue";
import { ApplicationBudget } from '@/entities';
import { Locales } from "@/i18n/locales";
import 'vuetify/dist/vuetify.min.css'
import '@pan-gms/vuetify-jsonschema-form/dist/main.css';

const namespace: string = "application";

@Component({
    components: {
        TopNavigationComponent,
        VJsonschemaForm
    }
})
export default class GenericComponent extends Vue {

    @Prop() appData!: any;
    @Prop() selectedKey!: string;
    @Prop() readOnly: boolean;
    @Getter("applicationBudget", { namespace }) budget: ApplicationBudget; 
    @Getter("rootTemplate", { namespace }) schema: any;

    /** declare variables */
    schemaformKey = 0;
    formValid: boolean = false;
    isDirty: boolean = false;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;
    options: any = {
        disableAll: (this.readOnly && this.readOnly === true) ? true : false,
        locale: this.defaultLocale
    };

    mounted() {
    }

    /** get schema properties to populate the left panel*/
    get subSchema(): any {
        if(this.schema.properties){
            return this.schema.properties[this.selectedKey];
        } else {
            return {};
        }
    }

    /** application data */
    get datum(): any {
        return this.appData;
    }

    /** error event */
    showError(err) {
        window.alert(err)
    }

    /** change event */
    showChange(e) {
        this.isDirty = true
        // console.log('"change" event', e)
    }

    /** input event */
    showInput(e) {
        this.isDirty = true
        // console.log('"input" event', e)
    } 

    /** top menu change event */
    topMenuChanged(key){
        this.$emit('change', key);
    }

    /** Save the application */
    save(){
        
    }
    /** watch state and update the variable */
    @Watch("appData")
    onDataChanged(value: any) {
        this.schemaformKey += 1;
    }

}
